<template>
  <div class="productInfo">
    <div class="box">
      <h4>{{obj.title}}</h4>
      <ul v-lazy-container="{ selector: 'img' }">
        <li v-for="(app,index) in obj.imgArr" :key="index">
          <img class="yuanjiao img-thumbnail" :data-src="imgUrl+app+'!sy'" :data-loading="imgUrl+'/images/chang_load.png!ty'">
        </li>
        <li class="content">— 到底了 —</li>
      </ul>
    </div>
    <div class="footerBox">
      <router-link tag='a' class="btn btn-light rounded-pill selfbtn" :to="{path:'/contact'}">&nbsp;&nbsp;联系我们深入了解> &nbsp;</router-link>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';

export default {
  name: 'productInfo',
  mixins: [generalMix],
  props:['obj','closeRightBoxFun'],
  data () {
    return {
    }
  },
  methods:{
  },
  mounted() {
    // var top = $(document).scrollTop();
    // $(document).on('scroll.unable',function (e) {
    //   $(document).scrollTop(top);
    // })
  },
  destroyed() {
    // $(document).unbind('scroll.unable');
  }
}
</script>

<style scoped lang='less'>

.productInfo {
  box-shadow: 0 0 1.5rem rgba(18, 38, 63, .2);
  background: #FFFFFF;
  width: 480px;
  height: 90%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 0;
  border-radius: 25px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  div.footerBox{
    background: rgba(255,255,255,1);
    text-align: center;
    padding: 15px 0;
    box-shadow: 0 0 0 rgba(18, 38, 63, 0.03);
  }
  /*通用滚动条样式*/
  div.box{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
    overflow-x: hidden;
    h4{
      border-bottom: 1px solid #EFF2F7;
      margin-bottom: 50px;
      font-size: 22px;
      padding: 45px 15px;
      text-align: center;
    }
    ul{
      margin-bottom: 40px;
      li{
        text-align: center;
        padding-left:3px;
        margin-bottom: 20px;
        &:last-child{
          margin: 0;
        }
        img{
          width: 90%;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .productInfo {
    width: 80vw;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/productinfo.vue